module.exports = __webpack_public_path__ + "img/bg2.ed5551e0.png";